import "react-app-polyfill/ie11";
import "react-app-polyfill/jsdom";
import "core-js";
//import "raf/polyfill";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Frame from "./layout/Frame";

ReactDOM.render(<Frame />, document.getElementById("root"));
